import { render, staticRenderFns } from "./RecoveryPass.vue?vue&type=template&id=6a7b83a6"
import script from "./RecoveryPass.vue?vue&type=script&lang=js"
export * from "./RecoveryPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports